import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoBack, LazySvgoBell, LazySvgoCard, LazySvgoCart, LazySvgoCatalog, LazySvgoCheck, LazySvgoChevronDown, LazySvgoChevronLeft, LazySvgoChevronRight, LazySvgoChevronUp, LazySvgoClock, LazySvgoCopy, LazySvgoCross, LazySvgoDeliveryBoxberry, LazySvgoDeliveryEms, LazySvgoDeliveryExpressMkad, LazySvgoDeliveryPinBoxberrySelected, LazySvgoDeliveryPinBoxberry, LazySvgoDeliveryPinSdekSelected, LazySvgoDeliveryPinSdek, LazySvgoDeliveryPinShopSelected, LazySvgoDeliveryPinShop, LazySvgoDeliveryRussianPost, LazySvgoDeliverySdek, LazySvgoDeliveryShop, LazySvgoDialog, LazySvgoDone, LazySvgoEdit, LazySvgoFilter, LazySvgoHInCircle, LazySvgoHeart, LazySvgoHistory, LazySvgoHome, LazySvgoLogin, LazySvgoLogoOld, LazySvgoLogoSmall, LazySvgoLogo, LazySvgoLoyaltyF, LazySvgoMeetball, LazySvgoMenu, LazySvgoMinusIcon, LazySvgoNew, LazySvgoNoPhotoBig, LazySvgoNoPhotoSmall, LazySvgoNotificationsBonus, LazySvgoNotificationsOrder, LazySvgoNotificationsQuestion, LazySvgoNotificationsTestimonial, LazySvgoNovaLogo, LazySvgoPaymentSystemMasterCard, LazySvgoPaymentSystemMir, LazySvgoPaymentSystemVisa, LazySvgoPhone, LazySvgoPhoto, LazySvgoPin, LazySvgoPlusIcon, LazySvgoProfile, LazySvgoPuzzle, LazySvgoQuestion, LazySvgoRefresh, LazySvgoReview, LazySvgoSale, LazySvgoSbpLogo, LazySvgoSbp, LazySvgoSearch, LazySvgoShare, LazySvgoShipment, LazySvgoSkull404, LazySvgoSocialInst, LazySvgoSocialTelegram, LazySvgoSocialTiktok, LazySvgoSocialVk, LazySvgoSocialYandex, LazySvgoSocialYoutube, LazySvgoSpecialOffers, LazySvgoSpinner, LazySvgoStarEmpty, LazySvgoStar, LazySvgoThumbsUp, LazySvgoTrashBin, LazySvgoVideoButton, LazySvgoVideo, LazySvgoWallet, LazySvgoYaSplit, LazySvgoYandexSplitPacman } from '#components'
const lazyGlobalComponents = [
  ["SvgoBack", LazySvgoBack],
["SvgoBell", LazySvgoBell],
["SvgoCard", LazySvgoCard],
["SvgoCart", LazySvgoCart],
["SvgoCatalog", LazySvgoCatalog],
["SvgoCheck", LazySvgoCheck],
["SvgoChevronDown", LazySvgoChevronDown],
["SvgoChevronLeft", LazySvgoChevronLeft],
["SvgoChevronRight", LazySvgoChevronRight],
["SvgoChevronUp", LazySvgoChevronUp],
["SvgoClock", LazySvgoClock],
["SvgoCopy", LazySvgoCopy],
["SvgoCross", LazySvgoCross],
["SvgoDeliveryBoxberry", LazySvgoDeliveryBoxberry],
["SvgoDeliveryEms", LazySvgoDeliveryEms],
["SvgoDeliveryExpressMkad", LazySvgoDeliveryExpressMkad],
["SvgoDeliveryPinBoxberrySelected", LazySvgoDeliveryPinBoxberrySelected],
["SvgoDeliveryPinBoxberry", LazySvgoDeliveryPinBoxberry],
["SvgoDeliveryPinSdekSelected", LazySvgoDeliveryPinSdekSelected],
["SvgoDeliveryPinSdek", LazySvgoDeliveryPinSdek],
["SvgoDeliveryPinShopSelected", LazySvgoDeliveryPinShopSelected],
["SvgoDeliveryPinShop", LazySvgoDeliveryPinShop],
["SvgoDeliveryRussianPost", LazySvgoDeliveryRussianPost],
["SvgoDeliverySdek", LazySvgoDeliverySdek],
["SvgoDeliveryShop", LazySvgoDeliveryShop],
["SvgoDialog", LazySvgoDialog],
["SvgoDone", LazySvgoDone],
["SvgoEdit", LazySvgoEdit],
["SvgoFilter", LazySvgoFilter],
["SvgoHInCircle", LazySvgoHInCircle],
["SvgoHeart", LazySvgoHeart],
["SvgoHistory", LazySvgoHistory],
["SvgoHome", LazySvgoHome],
["SvgoLogin", LazySvgoLogin],
["SvgoLogoOld", LazySvgoLogoOld],
["SvgoLogoSmall", LazySvgoLogoSmall],
["SvgoLogo", LazySvgoLogo],
["SvgoLoyaltyF", LazySvgoLoyaltyF],
["SvgoMeetball", LazySvgoMeetball],
["SvgoMenu", LazySvgoMenu],
["SvgoMinusIcon", LazySvgoMinusIcon],
["SvgoNew", LazySvgoNew],
["SvgoNoPhotoBig", LazySvgoNoPhotoBig],
["SvgoNoPhotoSmall", LazySvgoNoPhotoSmall],
["SvgoNotificationsBonus", LazySvgoNotificationsBonus],
["SvgoNotificationsOrder", LazySvgoNotificationsOrder],
["SvgoNotificationsQuestion", LazySvgoNotificationsQuestion],
["SvgoNotificationsTestimonial", LazySvgoNotificationsTestimonial],
["SvgoNovaLogo", LazySvgoNovaLogo],
["SvgoPaymentSystemMasterCard", LazySvgoPaymentSystemMasterCard],
["SvgoPaymentSystemMir", LazySvgoPaymentSystemMir],
["SvgoPaymentSystemVisa", LazySvgoPaymentSystemVisa],
["SvgoPhone", LazySvgoPhone],
["SvgoPhoto", LazySvgoPhoto],
["SvgoPin", LazySvgoPin],
["SvgoPlusIcon", LazySvgoPlusIcon],
["SvgoProfile", LazySvgoProfile],
["SvgoPuzzle", LazySvgoPuzzle],
["SvgoQuestion", LazySvgoQuestion],
["SvgoRefresh", LazySvgoRefresh],
["SvgoReview", LazySvgoReview],
["SvgoSale", LazySvgoSale],
["SvgoSbpLogo", LazySvgoSbpLogo],
["SvgoSbp", LazySvgoSbp],
["SvgoSearch", LazySvgoSearch],
["SvgoShare", LazySvgoShare],
["SvgoShipment", LazySvgoShipment],
["SvgoSkull404", LazySvgoSkull404],
["SvgoSocialInst", LazySvgoSocialInst],
["SvgoSocialTelegram", LazySvgoSocialTelegram],
["SvgoSocialTiktok", LazySvgoSocialTiktok],
["SvgoSocialVk", LazySvgoSocialVk],
["SvgoSocialYandex", LazySvgoSocialYandex],
["SvgoSocialYoutube", LazySvgoSocialYoutube],
["SvgoSpecialOffers", LazySvgoSpecialOffers],
["SvgoSpinner", LazySvgoSpinner],
["SvgoStarEmpty", LazySvgoStarEmpty],
["SvgoStar", LazySvgoStar],
["SvgoThumbsUp", LazySvgoThumbsUp],
["SvgoTrashBin", LazySvgoTrashBin],
["SvgoVideoButton", LazySvgoVideoButton],
["SvgoVideo", LazySvgoVideo],
["SvgoWallet", LazySvgoWallet],
["SvgoYaSplit", LazySvgoYaSplit],
["SvgoYandexSplitPacman", LazySvgoYandexSplitPacman],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
